import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@circle-react-shared/ModalsV2/ConfirmationModal";

interface BlockDmsModalProps {
  memberName: string;
  onClose: () => void;
  onConfirm: () => void;
  showModal: boolean;
}

export const BlockDmsModal = ({
  showModal,
  onClose,
  onConfirm,
  memberName,
}: BlockDmsModalProps) => (
  <ConfirmationModal
    isOpen={showModal}
    onClose={onClose}
    size="lg"
    onConfirm={onConfirm}
    title={t("messaging.block_direct_messages_modal.title", {
      name: memberName,
    })}
    confirmText={t("confirm")}
  >
    {t("messaging.block_direct_messages_modal.description", {
      name: memberName,
    })}
  </ConfirmationModal>
);
